<template>
  <div class="main-content-container position-relative weekly-container">
    <div class="top-content-container">
      <b-row>
        <b-col>
          <b-breadcrumb class="pb-2 customer-breadcrumbs">
            <b-breadcrumb-item>
              <span
                @click="$router.push({ name: 'TaskDashboard' })"
                class="text-uppercase font-family-medium"
              >
                Tasks
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <span class="text-uppercase font-family-medium">
                Weekly
              </span>
            </b-breadcrumb-item>
          </b-breadcrumb>
          <h1
            class="font-lg primary-dark font-family-medium position-relative content-title"
          >
            Weekly
          </h1>
        </b-col>
        <b-col
          v-if="!isLoadingCustomers"
          class="d-flex justify-content-end"
          :style="{ paddingBottom: '3rem' }"
        >
          <div class="d-flex flex-column mt-4">
            <p class="d-inline secondary--text position-relative">
              Filter by
            </p>
            <b-form-select
              :options="eligibleCustomersList"
              @change="getSelectedCustomer"
              v-model="selectedCustomer"
            >
            </b-form-select>
            <!-- <multiselect
              v-model="selectedCustomer"
              @select="getSelectedCustomer"
              class="multiselect-weekly"
              :loading="isLoadingCustomers"
              selectLabel=""
              deselectLabel=""
              selectedLabel=""
              :options="eligibleCustomersList"
              track-by="id"
              placeholder="Customer Name"
              label="text"
            >
              <template slot="noResult">No customers found</template>
              <template slot="noOptions">No customers found</template>
              <template slot="caret" v-if="!isLoadingCustomers">
                <img
                  class="custom-caret"
                  src="../../../../assets/icons/dropdown_arrow.svg"
                  alt=""
                />
              </template>
            </multiselect> -->
          </div>
        </b-col>
      </b-row>
      <b-dropdown-divider class=""></b-dropdown-divider>
    </div>

    <b-row v-if="weeklyNotesList.length > 0" class="mx-0 mt-5 mb-5">
      <!-- Start list view headers -->
      <b-col
        md="12"
        xl="12"
        lg="12"
        class="headings-wrapper d-flex"
      >
        <b-col md="4" class="p-0">
          <p class="primary--text font-family-medium" style="">Customer name</p>
        </b-col>
        <b-col md="6" class="pl-0">
          <p class="primary--text font-family-medium px-0">Task</p>
        </b-col>
        <b-col md="2" class="date-header d-flex">
          <p class="primary--text font-family-medium ">
            Date
          </p>
        </b-col>
      </b-col>

      <!-- End list view headers -->

      <!-- Start skeleton loader -->
      <b-row v-if="isLoading" class="ml-3 mr-0 weekly-list-wrapper w-100">
        <b-col
          md="12"
          xl="12"
          lg="12"
          class="d-flex flex-column pl-2 pr-0 py-2 mx-0 handover-card-column"
        >
          <b-col
            v-for="(item, index) in 4"
            :key="index"
            md="12"
            xl="12"
            lg="12"
            class="px-2 py-2 handover-card-column"
          >
            <b-card no-body>
              <b-card-body class="px-4 py-2 d-flex align-items-center">
                <b-col md="3" class="p-0 d-flex align-items-center">
                  <b-skeleton
                    type="avatar"
                    width="4.4rem"
                    height="4.4rem"
                  ></b-skeleton>
                  <b-skeleton class="ml-5" width="50%"></b-skeleton>
                </b-col>
                <b-col md="6" class="pl-0 position-relative">
                  <b-skeleton width="50%"></b-skeleton>
                  <b-skeleton width="75%"></b-skeleton>
                  <b-skeleton width="85%"></b-skeleton>
                </b-col>
                <b-col md="2">
                  <b-skeleton width="50%"></b-skeleton>
                </b-col>
                <b-col md="1" class="d-flex justify-content-end ml-3">
                  <b-skeleton type="avatar" size="4.4rem"></b-skeleton>
                </b-col>
              </b-card-body>
            </b-card>
          </b-col>
        </b-col>
      </b-row>
      <!-- End skeleton loader -->

      <!-- List view start -->
      <div
        v-if="!isLoading && weeklyNotesList.length > 0"
        class="mr-0 weekly-list-wrapper w-100 card-holding-container"
      >
        <b-row
          v-for="item in weeklyNotesList"
          :key="item.id"
        >
          <b-col cols="12">
            <b-card
              no-body
              @click="navigateToViewNotes(item)"
              @mouseenter="showCardHover(item.id)"
              @mouseleave="undoCardHover(item.id)"
              class="border-primary-lighter border-radius-sm"
            >
              <b-card-body class="px-4 py-2 d-flex align-items-center">
                <b-col md="4" class="p-0 d-flex align-items-center">
                  <div
                    @click.stop="navigateToContact(item.participent.id)"
                    class="avatarClick"
                  >
                    <b-avatar
                      size="4.4rem"
                      :src="item.participent.avatar"
                      v-if="item.participent.avatar"
                    ></b-avatar>
                    <b-avatar
                      size="4.4rem"
                      v-else
                      class="bg--primary weekly-tasks-avatar"
                      :text="item.customerInitials"
                    ></b-avatar>
                  </div>
                  <h6 class="font-sm font-family-medium primary--text ml-4 my-0">
                    {{
                      `${item.participent.firstName} ${item.participent.lastName}`
                    }}
                  </h6>
                </b-col>
                <b-col md="6" class="pl-0 task-column">
                  <h6 class="font-sm primary--text font-family-medium">
                    {{ item.title }}
                  </h6>
                  <h6
                    class="font-sm secondary--text font-weight-normal"
                  >
                    {{
                      item.finalNotes.length > 50
                        ? `${item.finalNotes.substring(0, 50)}...`
                        : item.finalNotes
                    }}
                  </h6>
                </b-col>
                <b-col md="2" class="date-column">
                  <h6 class="font-sm primary--text font-family-regular ">
                    {{ item.modified ? getFormattedDate(item.modified) : "N/A" }}
                  </h6>
                </b-col>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <infinite-loading v-if="selectedCustomer" @infinite="filterNotesByCustomers">
        <div slot="no-more">No more tasks to load</div>
      </infinite-loading>

      <infinite-loading v-else @infinite="getAssistantNotes">
        <div slot="no-more">No more tasks to load</div>
      </infinite-loading>
      <!-- List view end -->
    </b-row>
    <b-row class="mt-5" v-if="weeklyNotesList.length === 0 && !isLoading">
      <b-col class="d-flex align-items-center justify-content-center">
        <h4 class="font-md primary--text font-family-medium">
          No notes found.
        </h4>
      </b-col>
    </b-row>
    <b-avatar
      v-if="!isLoading"
      button
      @click="
        $router.push({
          name: 'AddWeeklyTask',
          params: {
            selectedCustomer
          }
        })
      "
      size="4.8rem"
      class="floating-action-btn btn-danger mb-5 position-fixed cursor-pointer"
    >
      <img src="@/assets/icons/floating_plus.svg" alt="" />
    </b-avatar>
  </div>
</template>

<script>
import { getNotesListAssistant } from "@/apis/assistants";
import { getProfile } from "@/apis/auth";
// import Multiselect from "vue-multiselect";
import { getNotesListByCustomers } from "@/apis/common";
import moment from "moment";
import _ from "lodash"

export default {
  name: "PAWeeklyTasks",
  // components: {
  //   Multiselect,
  // },
  data() {
    return {
      assistantProfileId: "",
      customerInitials: "",
      customerFullName: "",
      eligibleCustomersList: [{ text: "Customer name", value: null }],
      selectedCustomer: null,
      defaultCustomer: { text: "All", id: "" },
      weeklyNotesList: [],
      isLoading: true,
      isLoadingCustomers: false,
      role: "",
      expandHover: false,
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true,
      currPage: 1,
      pageSize: 5
    };
  },
  created() {
    getProfile()
      .then(res => {
        this.assistantProfileId = res.data.defaultProfile.id;
        this.getAssistantCustomers();
        this.getAssistantNotes();
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    navigateToViewNotes(item) {
      this.$router.push({
        name: "ViewWeeklyTask",
        params: {
          assistantId: item.organizer.id,
          notesId: item.id
        }
      });
    },
    showCardHover(id) {
      this.activeExpandHoverId = id;
      this.expandHover = true;
      this.showInactiveExpandHover = true;
    },
    undoCardHover(id) {
      this.inactiveExpandHoverId = id;
      this.expandHover = false;
    },
    getFormattedDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    
    getAssistantNotes($state) {
      getNotesListAssistant(
        this.assistantProfileId,
        false,
        this.pageSize,
        this.pageSize * (this.currPage - 1)
      )
        .then(res => {
          if (res.data.results.length) { // when data is coming on next load request
            let notesList = [...res.data.results].map(item => {
              item.strippedNotes = item.notes.replace(
                /<\/?(?!img)\w*\b[^>]*>/gi,
                ""
              );
              item.finalNotes = item.strippedNotes.replace(
                /<img[^>]*>/g,
                "Image added\n"
              );
              item.customerFullName = `${item.participent.firstName} ${item.participent.lastName}`;
              item.customerInitials = item.customerFullName
                .match(/\b(\w)/g)
                .join("");
              return item;
            });
            this.weeklyNotesList.push(...notesList); // pushing new loaded content in the existing notes list

            this.currPage += 1;
            $state.loaded();
          } else { // when there is no data on next load request
            $state.complete();
            this.isLoading = false;
          }
        })
        .catch(err => {
          console.log(err.response);
          this.isLoading = false;
        })
        .finally(() => {
          // this.isLoading = false;
        });
    },
    getAssistantCustomers() {
      getNotesListAssistant(
        this.assistantProfileId,
        true // to get only customers data
      )
        .then(res => {
          this.eligibleCustomersList.push({ // adding default value when nothing is selected
            value: null,
            text: "Customer name"
          });
          if (res.data.results.length) {
            let eligibleCustomersList = res.data.results.map(customer => {
              return {
                value: customer.id,
                text: `${customer.fullname}`
              }
            });
            this.eligibleCustomersList.push(...eligibleCustomersList);
            this.eligibleCustomersList = _.uniqBy(this.eligibleCustomersList, 'value');
          } else {
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    filterNotesByCustomers($state) {
      getNotesListByCustomers(
        this.selectedCustomer,
        this.pageSize,
        this.pageSize * (this.currPage - 1)
      )
        .then(res => {
          if (res.data.results.length) {
            let notesList = [...res.data.results].map(item => {
              item.strippedNotes = item.notes.replace(
                /<\/?(?!img)\w*\b[^>]*>/gi,
                ""
              );
              item.finalNotes = item.strippedNotes.replace(
                /<img[^>]*>/g,
                "\nImage added\n"
              );
              item.customerFullName = `${item.participent.firstName} ${item.participent.lastName}`;
              item.customerInitials = item.customerFullName
                .match(/\b(\w)/g)
                .join("");
              return item;
            });
            this.weeklyNotesList.push(...notesList); // pushing new loaded content in the existing notes list

            // this.eligibleCustomersList.push(...eligibleCustomersList); // pushing new loaded content in the existing customer list
            // this.eligibleCustomersList = _.uniqBy(this.eligibleCustomersList, 'value')
            this.currPage += 1;
            $state.loaded();
          } else { // when there is no data on next load request
            $state.complete();
            this.isLoading = false;
          }
        })
        .catch(err => {
          console.log(err.response);
        })
        .finally(() => {
          // this.isLoading = false;
        });
    },
    getSelectedCustomer() {
      this.isLoading = true;
      this.currPage = 1;
      this.weeklyNotesList.length = 0;
      if (this.selectedCustomer) {
        this.filterNotesByCustomers();
      } else {
        this.getAssistantNotes();
      }
    },
    navigateToContact(id) {
      this.$router.push({
        name: "CustomerDetails",
        params: {
          profileId: id
        },
        query: { tab: 2 }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.weekly-container {
  margin-bottom: 10rem;
}
.grid-list-action-icons {
  margin-top: -1.5rem;
  top: 40%;
  right: 0;
}
.weekly-list-wrapper {
  border-radius: 6px;
  margin-bottom: 2rem;
  padding: 5px;
  >.row {
    padding-bottom: 5px;
  }
  >.row:last-child { // :'(
    padding-bottom: 0;
  }
}
.floating-action-btn {
  right: 3rem;
  z-index: 2;
  bottom: 0;
}
.custom-caret {
  position: absolute;
  right: 1rem;
  top: 2.2rem;
  z-index: 2;
}
.avatarClick:hover {
  cursor: pointer;
}
.card {
  cursor: pointer;
}
.task-column {
  h6 {
    padding: 1rem 0;
    line-height: normal;
    margin-bottom: 0;
  }
}
.date-column {
  h6 {
    line-height: normal;
    margin-bottom: 0;
  }
}
.headings-wrapper {
  padding: 5px 18.5px;
}
</style>
